export default "static/media/computer.4212cf5.svg"